import {
  useGetAllMonitoringVisitMutation,
  useGetMonitoringVisitAuditFilterDataMutation,
  useImvCheckInMutation,
  useImvCheckOutMutation,
  useInvestigatorSignMutation,
  useLazyUpdateActivityQuery,
  useMvPublishToEtmfMutation,
  useMvPublishToIsfMutation,
  useRepresentativeSignMutation,
  useSiCheckInMutation,
  useSqCheckInMutation,
  useUpdateVisitPurposeMutation
} from 'src/services/MonitoringVisitLog';

export const useMonitoringVisitLog = () => {
  const [
    getAllMonitoringVisits,
    {
      data: monitoringVisitData,
      error: monitoringVisitError,
      isError: monitoringVisitIsError,
      isLoading: monitoringVisitIsLoading,
      isSuccess: monitoringVisitIsSuccess
    }
  ] = useGetAllMonitoringVisitMutation();
  const [
    imvCheckIn,
    {
      data: imvCheckInData,
      error: imvCheckInError,
      isError: imvCheckInIsError,
      isLoading: imvCheckInIsLoading,
      isSuccess: imvCheckInIsSuccess
    }
  ] = useImvCheckInMutation();

  const [
    imvCheckOut,
    {
      data: imvCheckOutData,
      error: imvCheckOutError,
      isError: imvCheckOutIsError,
      isLoading: imvCheckOutIsLoading,
      isSuccess: imvCheckOutIsSuccess
    }
  ] = useImvCheckOutMutation();

  const [getauditFilterData, { isLoading: auditFilterLoading, data: auditFilterData, error: auditFilterError }] =
    useGetMonitoringVisitAuditFilterDataMutation();

  const [
    updateVisitPurpose,
    {
      data: updatePurposeData,
      error: updatePurposeError,
      isError: updatePurposeIsError,
      isLoading: updatePurposeIsLoading,
      isSuccess: updatePurposeIsSuccess
    }
  ] = useUpdateVisitPurposeMutation();

  const [
    investigatorSign,
    {
      data: investigatorSignData,
      error: investigatorSignError,
      isError: investigatorSignIsError,
      isLoading: investigatorSignIsLoading,
      isSuccess: investigatorSignIsSuccess
    }
  ] = useInvestigatorSignMutation();
  const [
    representativeSign,
    {
      data: representativeSignData,
      error: representativeSignError,
      isError: representativeSignIsError,
      isLoading: representativeSignIsLoading,
      isSuccess: representativeSignIsSuccess
    }
  ] = useRepresentativeSignMutation();

  const [
    sqCheckIn,
    {
      data: sqCheckInData,
      error: sqCheckInError,
      isError: sqCheckInIsError,
      isLoading: sqCheckInIsLoading,
      isSuccess: sqCheckInIsSuccess
    }
  ] = useSqCheckInMutation();

  const [
    siCheckIn,
    {
      data: siCheckInData,
      error: siCheckInError,
      isError: siCheckInIsError,
      isLoading: siCheckInIsLoading,
      isSuccess: siCheckInIsSuccess
    }
  ] = useSiCheckInMutation();
  const [
    updateMonitoringVisitActivity,
    {
      data: updateMonitoringVisitActivityData,
      error: updateMonitoringVisitActivityError,
      isError: updateMonitoringVisitActivityIsError,
      isLoading: updateMonitoringVisitActivityIsLoading,
      isSuccess: updateMonitoringVisitActivityIsSuccess
    }
  ] = useLazyUpdateActivityQuery();

  const [
    mvPublishToIsf,
    {
      data: mvPublishToIsfData,
      error: mvPublishToIsfError,
      isError: mvPublishToIsfIsError,
      isLoading: mvPublishToIsfIsLoading,
      isSuccess: mvPublishToIsfIsSuccess
    }
  ] = useMvPublishToIsfMutation();
  const [
    mvPublishToEtmf,
    {
      data: mvPublishToEtmfData,
      error: mvPublishToEtmfError,
      isError: mvPublishToEtmfIsError,
      isLoading: mvPublishToEtmfIsLoading,
      isSuccess: mvPublishToEtmfIsSuccess
    }
  ] = useMvPublishToEtmfMutation();

  return {
    imvCheckInData,
    imvCheckInError,
    imvCheckInIsError,
    imvCheckInIsLoading,
    imvCheckInIsSuccess,
    imvCheckIn,
    imvCheckOutData,
    imvCheckOutError,
    imvCheckOutIsError,
    imvCheckOutIsLoading,
    imvCheckOutIsSuccess,
    imvCheckOut,
    auditFilterLoading,
    auditFilterData,
    auditFilterError,
    getauditFilterData,
    monitoringVisitData,
    monitoringVisitError,
    monitoringVisitIsError,
    monitoringVisitIsLoading,
    monitoringVisitIsSuccess,
    getAllMonitoringVisits,
    updatePurposeData,
    updatePurposeIsError,
    updatePurposeError,
    updatePurposeIsSuccess,
    updatePurposeIsLoading,
    updateVisitPurpose,
    sqCheckInData,
    sqCheckInError,
    sqCheckInIsError,
    sqCheckInIsLoading,
    sqCheckInIsSuccess,
    sqCheckIn,
    siCheckInData,
    siCheckInError,
    siCheckInIsError,
    siCheckInIsLoading,
    siCheckInIsSuccess,
    siCheckIn,
    investigatorSignData,
    investigatorSignError,
    investigatorSignIsError,
    investigatorSignIsLoading,
    investigatorSignIsSuccess,
    investigatorSign,
    representativeSignData,
    representativeSignError,
    representativeSignIsError,
    representativeSignIsLoading,
    representativeSignIsSuccess,
    representativeSign,
    updateMonitoringVisitActivityData,
    updateMonitoringVisitActivityError,
    updateMonitoringVisitActivityIsError,
    updateMonitoringVisitActivityIsLoading,
    updateMonitoringVisitActivityIsSuccess,
    updateMonitoringVisitActivity,
    mvPublishToIsfData,
    mvPublishToIsfError,
    mvPublishToIsfIsError,
    mvPublishToIsfIsLoading,
    mvPublishToIsfIsSuccess,
    mvPublishToIsf,
    mvPublishToEtmfData,
    mvPublishToEtmfError,
    mvPublishToEtmfIsError,
    mvPublishToEtmfIsLoading,
    mvPublishToEtmfIsSuccess,
    mvPublishToEtmf
  };
};
